/* KOYO-CUSTOM: ada-carousel-state — name and role for the slideshow play/pause control (WCAG 4.1.2).
 *
 * Xtra builds the control with append_url(el, 'Play/Pause', 'play-pause'), which produces
 * <a href="#" class="play-pause">Play/Pause</a> on the .m6fr slider. Operability was already fine — the
 * 2026-08-18 VoiceOver run stopped and resumed autoplay through it — but it announced as a link named
 * "Play/Pause" in both states, so a screen-reader user could not tell what pressing it would do.
 *
 * The label changes rather than carrying aria-pressed. The visible label is the icon alone (screen.css
 * pushes the text off with text-indent:-3000em), so there is no visible text for the accessible name to
 * preserve, and for a control whose action alternates, a state-specific name is the clearer pattern.
 * State is read from the .paused class Xtra toggles, which also covers the mouseleave restart — autoplay
 * can resume without the control being pressed.
 */
(function () {
  'use strict';

  if (window.__koyoA11yCarousel) return; // idempotent: never bind a control twice
  window.__koyoA11yCarousel = true;

  var LABEL_PLAY = 'Play slideshow';
  var LABEL_PAUSE = 'Pause slideshow';

  function host(control) {
    return control.closest('.m6fr') || control.parentElement;
  }

  function sync(control) {
    var el = host(control);
    var paused = Boolean(el && el.classList.contains('paused'));
    var label = paused ? LABEL_PLAY : LABEL_PAUSE;
    if (control.getAttribute('aria-label') !== label) control.setAttribute('aria-label', label);
  }

  function adopt(control) {
    if (control.getAttribute('data-koyo-a11y') === '1') return;
    control.setAttribute('data-koyo-a11y', '1');
    // It never navigates (href="#"), and it is now announced as a button, so Space has to work: an <a>
    // activates on Enter only.
    control.setAttribute('role', 'button');
    control.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        control.click();
      }
    });

    var el = host(control);
    if (el) {
      new MutationObserver(function () {
        sync(control);
      }).observe(el, { attributes: true, attributeFilter: ['class'] });
    }
    sync(control);
  }

  function scan() {
    var controls = document.querySelectorAll('a.play-pause');
    for (var i = 0; i < controls.length; i++) adopt(controls[i]);
  }

  function install() {
    scan();
    // Sliders initialize after load and on Xtra's own events, so the control may not exist yet.
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        scan();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install);
  else install();
})();
